import { Flex, GridAlpha, Text } from '@applyboard/crystal-ui'
import { ApplicationDetailFile } from '../ApplicationDetailFile'
import { format } from 'date-fns'
import { SchoolAdditionalDocument } from '../../../../hooks'

type ApplicationDetailAdditionalDocumentsProps = Readonly<{
  files?: Array<SchoolAdditionalDocument>
}>

export function ApplicationDetailAdditionalDocuments(
  props: ApplicationDetailAdditionalDocumentsProps,
) {
  if (!props.files?.length) {
    return <Text>There are no files available yet.</Text>
  }

  return (
    <GridAlpha
      columns={{
        xs: 'auto',
        lg: 'repeat(2, 1fr)',
      }}
      columnGap={20}
      rowGap={6}
    >
      {props.files.map(file => (
        <GridAlpha.Item key={file.hash}>
          <Flex direction="column" gap={2}>
            <ApplicationDetailFile name={file.fileName} url={file.url} />
            <Text variant="labelS" contrast="mid">
              {`Uploaded on ${format(new Date(file.uploadedAt), 'dd MMM yyyy')}`}
            </Text>
          </Flex>
        </GridAlpha.Item>
      ))}
    </GridAlpha>
  )
}
